export default __webpack_public_path__ + "i18n/ru.88a9a039d034741e80c6feeddd6f45b9.json";